import { makeStyles } from '@material-ui/core/styles';
import _get from 'lodash/get';
import { TOOLTIP_TEXT_COLOR } from '../../../../reports-constants';

export const useStyles = makeStyles((theme) => {
  _get(theme, 'palette.bars.blueDark', '#142A35');
  return {
    container: {
      alignItems: 'center',
      width: '300px',
      backgroundColor: 'white',
      borderRadius: '4px',
      color: TOOLTIP_TEXT_COLOR,
      border: '1px solid #ccc',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      display: 'flex',
      justifyContent: 'center',
      fontSize: '14px',
      flexDirection: 'row',
      padding: '10px 15px',
      position: 'relative',
      '&:before': {
        content: '""',
        bottom: '0',
        left: '50%',
        height: '6px',
        width: '6px',
        background: 'white',
        border: '1px solid #ccc',
        position: 'absolute',
        transform: 'translateY(50%) rotate(45deg) skew(15deg, 15deg)',
        zIndex: '-1',
      },
    },
  };
});
